import { defineStore } from 'pinia'
import { ref } from 'vue'
import { persistPiniaSlice, loadPiniaSlice } from '../persist'

export const useBlockStore = defineStore('block', () => {
    const selectedBlock = ref(null)

    const persist = () => {
        persistPiniaSlice('blockStore', {
            selectedBlock: selectedBlock.value,
        })
    }

    const selectBlock = (block) => {
        selectedBlock.value = block
        persist()
    }

    const resetBlocks = () => {
        selectedBlock.value = null
        persist()
    }

    const saved = loadPiniaSlice('blockStore')
    if (saved && Object.prototype.hasOwnProperty.call(saved, 'selectedBlock')) {
        selectedBlock.value = saved.selectedBlock
    }

    return {
        selectedBlock,
        selectBlock,
        resetBlocks,
    }
})
